/* Gorilla Vapes — cart near-miss offer nudge.
   Reads the JSON published by snippets/gv-cart-nudge.liquid (each cart line's
   product offers from gv_offers.card), pools quantities by offer id so a
   mix-&-match offer counts across flavours, finds the next unreached tier, and
   renders "Add N more to unlock …" with a progress bar into every
   .gv-cart-nudges mount. Recomputes whenever the cart re-renders. */
(function () {
  'use strict';
  var DATA = '.gv-cart-offer-data';
  var MOUNT = '.gv-cart-nudges';
  var scheduled = false;

  function money(pence) {
    var n = (Number(pence) || 0) / 100;
    var s = n.toFixed(2).replace(/\.00$/, '');
    return '£' + s; // £
  }

  // Singularise a product-group name when the customer needs just one more
  // (e.g. "Shortfills" -> "Shortfill", "Nic Salts" -> "Nic Salt").
  function singular(word) {
    if (/ies$/i.test(word)) return word.replace(/ies$/i, 'y');
    if (/(ses|xes|zes|ches|shes)$/i.test(word)) return word.replace(/es$/i, '');
    if (/ss$/i.test(word)) return word;
    if (/s$/i.test(word)) return word.replace(/s$/i, '');
    return word;
  }

  function nextTierText(offer, qty, group) {
    if (!offer || (offer.kind !== 'qty' && offer.kind !== 'mix')) return null;
    var tiers = Array.isArray(offer.tiers) ? offer.tiers.slice() : [];
    if (!tiers.length) return null;
    tiers.sort(function (a, b) { return a.qty - b.qty; });
    var next = null;
    for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty > qty) { next = tiers[i]; break; } }
    if (!next) return null;            // already at/above the top tier
    var need = next.qty - qty;
    var deal;
    if (offer.mode === 'percent' && next.pct != null) deal = next.qty + ' for ' + next.pct + '% off';
    else if (offer.mode === 'amount' && next.pence != null) deal = 'save ' + money(next.pence) + ' on ' + next.qty;
    else if (next.pence != null) deal = next.qty + ' for ' + money(next.pence);
    else return null;
    // Name the product group so the customer knows WHAT to add (their product
    // type, e.g. "Nic Salts"). Falls back to "items" only for mixed-type pools.
    var what = group ? (need === 1 ? singular(group) : group) : (need === 1 ? 'item' : 'items');
    return {
      need: need,
      pct: Math.max(5, Math.min(100, Math.round((qty / next.qty) * 100))),
      html: 'Add <strong>' + need + '</strong> more ' + what +
            ' to unlock <strong>' + deal + '</strong>'
    };
  }

  function compute() {
    var dataEl = document.querySelector(DATA);
    if (!dataEl) return [];
    var items;
    try { items = JSON.parse(dataEl.textContent || '[]'); } catch (e) { return []; }
    var byOffer = {};
    for (var i = 0; i < items.length; i++) {
      var offers = items[i].offers || [];
      for (var j = 0; j < offers.length; j++) {
        var o = offers[j];
        if (!o || o.id == null) continue;
        if (o.kind !== 'qty' && o.kind !== 'mix') continue;
        if (!byOffer[o.id]) byOffer[o.id] = { offer: o, qty: 0, types: {} };
        byOffer[o.id].qty += (Number(items[i].qty) || 0);
        if (items[i].type) byOffer[o.id].types[items[i].type] = true;
      }
    }
    var out = [];
    for (var id in byOffer) {
      if (!byOffer.hasOwnProperty(id)) continue;
      var e = byOffer[id];
      if (e.qty <= 0) continue;        // don't nag a basket that hasn't started the offer
      var typeKeys = Object.keys(e.types);
      var group = typeKeys.length === 1 ? typeKeys[0] : null;  // one shared product type = the group name
      var n = nextTierText(e.offer, e.qty, group);
      if (n) out.push(n);
    }
    return out;
  }

  function render() {
    scheduled = false;
    var nudges = compute();
    var sig = JSON.stringify(nudges);
    var html = '';
    for (var i = 0; i < nudges.length; i++) {
      var won = nudges[i].pct >= 100;
      html +=
        '<div class="gv-cart-nudge' + (won ? ' gv-cart-nudge--won' : '') + '">' +
          '<span class="gv-cart-nudge__icon" aria-hidden="true">🎁</span>' +
          '<div style="flex:1 1 auto">' +
            '<div>' + nudges[i].html + '</div>' +
            '<div class="gv-cart-nudge__bar"><span style="width:' + nudges[i].pct + '%"></span></div>' +
          '</div>' +
        '</div>';
    }
    var mounts = document.querySelectorAll(MOUNT);
    for (var m = 0; m < mounts.length; m++) {
      // Skip if unchanged — prevents the MutationObserver from looping on our
      // own injection.
      if (mounts[m].getAttribute('data-gv-sig') === sig) continue;
      mounts[m].setAttribute('data-gv-sig', sig);
      mounts[m].innerHTML = html;
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(render, 16);
  }

  function init() {
    render();
    var targets = ['#CartDrawer-CartItems', '#main-cart-items', 'cart-drawer', 'cart-items'];
    var obs = new MutationObserver(schedule);
    for (var i = 0; i < targets.length; i++) {
      var el = document.querySelector(targets[i]);
      if (el) obs.observe(el, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
